import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase environment variables');
}

// Verificar se estamos no cliente (browser)
const isBrowser = typeof window !== 'undefined';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: isBrowser ? window.localStorage : undefined,
        storageKey: 'sb-driver-financas-auth-token',
        flowType: 'pkce',
        // Configurações para melhorar a permanência de login
        persistSession: true,
    },
    global: {
        headers: {
            'X-Client-Info': 'driver-financas-web'
        }
    },
    // Configurações adicionais para melhorar estabilidade
    realtime: {
        params: {
            eventsPerSecond: 2
        }
    }
});
